import { Box, Stack, Typography } from "@mui/material";
import cpsImg from '../../../img/cps.png'

export default function FindRpps(){

    return (
        <Stack spacing={1}>

            <Box>

                <img 
                    src={cpsImg} 
                    alt='CPS' 
                    width={200} 
                    height={126} 
                />
            </Box>


            <Typography color="text.secondary" variant="body2">
                Vous pouvez aussi retrouver votre n° RPPS sur un moteur de recherche (ex : Google...) en écrivant votre "Prénom Nom numéro RPPS".
            </Typography>
                                
        </Stack>
    )
}